function getAnchorTime(el, anchor) {
  return anchor == 'start' ? el.getStartTime() : el.getEndTime();
}

function getDependencyAnchors(dependencyType, isSuccessor) {
  if (dependencyType == 'SS') return { sourceAnchor: 'start', targetAnchor: 'start' };
  if (dependencyType == 'FF') return { sourceAnchor: 'end', targetAnchor: 'end' };
  return isSuccessor
    ? { sourceAnchor: 'end', targetAnchor: 'start' } // FS successor
    : { sourceAnchor: 'start', targetAnchor: 'end' }; // FS predecessor
}

export {
  getAnchorTime,
  getDependencyAnchors,
};
